__turbopack_context__.v({
  "className": "roboto_7a0fe2f1-module__R3JvSG__className",
});
